__turbopack_context__.v({
  "body_rich_text": "Resource-module-scss-module__k9z8Ia__body_rich_text",
  "direction__column": "Resource-module-scss-module__k9z8Ia__direction__column",
  "direction__row": "Resource-module-scss-module__k9z8Ia__direction__row",
  "gradient-glow-blue": "Resource-module-scss-module__k9z8Ia__gradient-glow-blue",
  "gradient-glow-neon": "Resource-module-scss-module__k9z8Ia__gradient-glow-neon",
  "gradient-glow-orange": "Resource-module-scss-module__k9z8Ia__gradient-glow-orange",
  "gradient-glow-pink": "Resource-module-scss-module__k9z8Ia__gradient-glow-pink",
  "gradient-glow-snap-pea": "Resource-module-scss-module__k9z8Ia__gradient-glow-snap-pea",
  "gradient-neon-pink": "Resource-module-scss-module__k9z8Ia__gradient-neon-pink",
  "gradient-pink-blue": "Resource-module-scss-module__k9z8Ia__gradient-pink-blue",
  "gradient-pink-orange": "Resource-module-scss-module__k9z8Ia__gradient-pink-orange",
  "layout__content-leading": "Resource-module-scss-module__k9z8Ia__layout__content-leading",
  "layout__content-trailing": "Resource-module-scss-module__k9z8Ia__layout__content-trailing",
  "module-base": "Resource-module-scss-module__k9z8Ia__module-base",
  "module-content": "Resource-module-scss-module__k9z8Ia__module-content",
  "module-content-swap": "Resource-module-scss-module__k9z8Ia__module-content-swap",
  "module-image": "Resource-module-scss-module__k9z8Ia__module-image",
  "module-paragraph-container": "Resource-module-scss-module__k9z8Ia__module-paragraph-container",
  "module_block__contained": "Resource-module-scss-module__k9z8Ia__module_block__contained",
  "module_block__uncontained": "Resource-module-scss-module__k9z8Ia__module_block__uncontained",
  "module_breadcrumbs": "Resource-module-scss-module__k9z8Ia__module_breadcrumbs",
  "section_bg_fill__base": "Resource-module-scss-module__k9z8Ia__section_bg_fill__base",
  "section_bg_fill__gradient": "Resource-module-scss-module__k9z8Ia__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "Resource-module-scss-module__k9z8Ia__section_bg_fill__no-fill",
  "section_bg_fill__raised": "Resource-module-scss-module__k9z8Ia__section_bg_fill__raised",
  "section_container": "Resource-module-scss-module__k9z8Ia__section_container",
  "with_breadcrumb": "Resource-module-scss-module__k9z8Ia__with_breadcrumb",
  "with_navbar": "Resource-module-scss-module__k9z8Ia__with_navbar",
});
